var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.grid)?_c('jobEnviaDadosWsRestGrid',{on:{"editItem":_vm.editItem}}):_c('jobEnviaDadosWsRestForm',{attrs:{"tenantUpdating":_vm.tenant},on:{"editItem":_vm.editItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }